module.exports = __webpack_public_path__ + "static/media/TS.2e6ea225.jpg";